<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Instrument Form Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading :title="`Update ${instrument.formatAbbrev()}`" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'edit instrument'">
      <template #gated-content>
        <instrument-form :instrument="instrument" @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import InstrumentForm from "@/components/lab/instrument/InstrumentForm";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { getModel } from "@/shared/fetch-utils";
import { instrumentNotifications } from "@/shared/notifications";
import { notificationOptions } from "@/shared/toast-notification-options";

const InstrumentRepository = LabRepositoryFactory.get("instrument");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "InstrumentEdit",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    InstrumentForm,
    PermissionAlertGate,
  },
  data() {
    return {
      loading: true,
      instrument_id: this.$route.params.instrument_id || null,
      instrument: null,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/instrument",
            title: "Instrument list",
          },
          {
            icon: "fa-eye",
            linkto: `/instrument/${this.instrument_id}`,
            title: "View instrument",
            variant: "info",
          },
        ],
      };
    },
  },
  methods: {
    async submit(form_data) {
      try {
        await InstrumentRepository.update(this.instrument_id, form_data);
        this.editSuccess();
      } catch ({ response }) {
        this.editFail();
      }
    },
  },
  async created() {
    this.loading = true;

    this.instrument = await getModel({
      model_type: "instrument",
      id: this.instrument_id,
      message: this.$bvToast,
    });

    this.loading = false;
  },
  notifications: instrumentNotifications,
};
</script>
